var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 285,
    viewBox: "0 0 280 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M234.232 69.5045C236.257 79.136 238.463 89.1804 240.913 99.4956C244.211 109.398 247.74 119.686 251.387 130.276C255.756 140.604 260.033 151.354 264.036 162.389C268.378 173.207 272.082 184.227 274.911 195.145C277.58 205.522 278.944 215.407 278.764 224.33C276.587 235.327 261.159 246.816 247.913 246.895C237.973 245.495 226.606 243.013 214.167 239.961C202.111 237.59 190.143 235.843 178.563 235.089C167.896 236.049 157.639 238.203 147.802 241.386C138.664 246.112 129.553 251.378 120.365 256.74C111.382 262.817 101.975 268.355 92.1699 272.996C82.325 277.568 72.0905 280.816 61.7398 282.548C51.6002 283.765 41.7002 283.278 32.4679 281.004C23.9822 278.019 16.6247 273.199 10.7758 266.539C6.07271 259.128 3.06161 249.947 1.86027 239.086C1.64973 227.668 2.92095 215.322 5.24865 202.394C7.80089 189.326 10.8554 175.909 14.0956 162.401C16.8905 149.038 19.5526 135.697 21.9972 122.532C23.7417 109.669 25.3012 97.0151 26.7871 84.7459C27.7959 72.917 29.0396 61.5753 30.7451 50.9361C32.4236 40.9977 34.9644 31.9579 38.6112 24.0618C42.6197 17.1354 48.0141 11.4983 54.8944 7.305C62.2735 4.04371 71.1409 2.06664 81.4173 1.32629C91.918 0.960613 103.027 1.34666 114.391 2.20872C125.478 2.673 136.53 3.26245 147.254 3.87843C157.393 3.78272 167.056 3.75682 176.07 3.91225C188.207 3.54787 207.749 5.74865 215.008 9.31891C220.682 14.2176 227.987 30.8557 230.129 42.4257C231.58 50.4294 232.908 59.4782 234.232 69.5045Z",
    stroke: "#5A42ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "11 7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector15);
export default __webpack_public_path__ + "static/media/Vector-15.a85e9233b145306115b278e1ff85d443.svg";
export { ForwardRef as ReactComponent };